import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertPassouFalhouEnumToBoolean, convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta16Model } from './model-consultaSeguimentoPergunta16'

export const convertConsultaSeguimentoPergunta16ToInput = (
  value: ConsultaSeguimentoPergunta16Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_16_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_16_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_16_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_16_EXEMPLOS?.PASSOU?.OLHA_PARA_O_QUE_VOCE_ESTA_OLHANDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_16_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_16_EXEMPLOS?.PASSOU?.APONTA_PARA_O_QUE_VOCE_ESTA_OLHANDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_16_04,
      stResposta: convertSimNaoEnumToBoolean(
        value.PERGUNTA_16_EXEMPLOS?.PASSOU?.OLHA_AO_REDOR_PARA_O_QUE_VOCE_ESTA_OLHANDO
      ),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_16_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_16_EXEMPLOS?.FALHOU?.NAO_REPARA_EM_VOCE),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_16_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_16_EXEMPLOS?.FALHOU?.OLHA_PARA_SEU_ROSTO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_16_07,
      stResposta: convertPassouFalhouEnumToBoolean(value.PERGUNTA_16_FREQUENCIA),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
